import autoText from 'ui/autotext/house';
import AbstractSelect from './abstract.js';

export default class HouseSelect extends AbstractSelect {
    init(elements = {}) {
        super.init(elements);

        this.at = autoText.init(
            this.element,
            {
                type: 'house',
                cantBeEmpty: true,
                streetRequired: true,
                requireData: true,
            },
            {
                onselect: ::this._onSelect,
                emptyselect: ::this._onDropSelect,
                ondrop: ::this._onDropSelect,
                accept: ::this._onAcceptSelect,
                open: ::this._onOpen,
            }
        );

        if (!this.at) {
            throw new Error('House autotext init error');
        }

        this.element.on('keyup change', () => {
            this.error = false;
        });

        console.log('House select init complete.');
    }

    drop() {
        super.drop();
        this.street = null;
    }

    set street(value) {
        this.at.options.street = value || null;
    }

    _onAcceptSelect() {
        this.events.trigger('accept');
    }

    get id() {
        var id = this.data.id;

        if (!id) {
            return null;
        }

        return parseInt(id, 10);
    }

    get name() {
        return this.data.name || this.val;
    }

    get coordinates() {
        const coords = this.data.coords;

        if (!coords) {
            return null;
        }

        return coords;
    }

    get geoObject() {
        const coords = this.data.geoObject;

        if (!coords) {
            return null;
        }

        return coords;
    }

    get val() {
        return this.at.val();
    }
}
